import React from 'react';
import { hidePopup } from '../../helpers/uiFunctions/uiActions';

class NewPromotionForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        return(
            <form className="form popup-form" id="addPromoForm" style={{display: 'none'}}>
                <i className="fas fa-times icon" onClick={() => hidePopup("addPromoForm")} style={{float: 'right'}}></i>
                <h3>Add New Promotion</h3>
                <p className="promo-error"></p>
                <div className="input-row">
                    <input type="text" className="input" id="promoName" placeholder="Promotion Name" />
                </div>
                <div className="input-row">
                    <label>Start Date</label>
                    <input type="date" id="promoStart" name="promoStart" />
                </div>
                <div className="input-row">
                    <label>End Date</label>
                    <input type="date" id="promoEnd" name="promoEnd" />
                </div>
                <div className="input-row">
                    <input type="button" className="button is-info" onClick={() => this.props.addPromotion("promoName", "promoStart", "promoEnd")} value="Add Promotion" />
                </div>
            </form>
        )
    }
}
export default NewPromotionForm;


// WEBPACK FOOTER //
// ./src/component_promotions/Explorer/NewPromo.js